/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ArrowUpSolidV6 = (props) => (
  <Icon {...props} name="Arrow Up Solid V6">
    <path d="M13.706 7.706a.997.997 0 0 1-1.413.001L9 4.416V14c0 .553-.448.972-.972.972S7 14.553 7 14V4.416L3.707 7.707a.999.999 0 1 1-1.414-1.414l5-5a.999.999 0 0 1 1.414 0l5 5a1 1 0 0 1-.001 1.414z" />
  </Icon>
);

export default ArrowUpSolidV6;
